import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, toast } from '@gitbook/spine-react';

import { useCommentActions } from './useCommentActions';

/** A button that shows either a resolve or unresolve button based on the comment's status. */
export function CommentResolveButton(props: {
    comment: api.Comment;
    commentReply?: api.CommentReply;
}) {
    const { onResolve, onUnresolve } = useCommentActions(props);
    const isResolved = props.comment.status === 'resolved';
    const label = isResolved ? 'Re-open' : 'Resolve';

    // Call the right function + show a toast success if successful
    const handlePress = async () => {
        await toast.catch(
            async () => {
                if (isResolved) {
                    await onUnresolve?.();
                    toast.success('Comment re-opened');
                } else {
                    await onResolve?.();
                    toast.success('Comment resolved');
                }
            },
            `Error while ${isResolved ? 're-opening' : 'resolving'} comment`
        );
    };

    return (
        <Button
            leadingIcon={isResolved ? Icon.RotateLeft : Icon.CheckCircle}
            size="small"
            onPress={handlePress}
            tooltip={{ position: 'top', label }}
            label={label}
            iconOnly
            kind="blank"
        />
    );
}
